import { DocumentStatus } from '@app/entities/enums/ptrab/documents/document-status.enum';

export class Document {
  id!: string;
  date!: string;
  subclass!: string;
  status!: DocumentStatus;
}
